<template>
  <validation-observer v-slot="{ invalid }" ref="formRef" class="form mx-auto">
    <b-form @submit.prevent="handleSubmit">
      <slot name="header">
        <h4 class="mb-4">Manage User Type</h4>
      </slot>

      <UserRoleSelect v-model="formData.type" />

      <div class="mt-4 d-flex justify-content-between">
        <slot name="return"></slot>

        <slot name="submit">
          <BaseButton
            :loading="isProcessing"
            :disabled="invalid"
            type="submit"
            class="form-btn font-weight-normal"
          >
            <slot name="submit-text">Save</slot>
          </BaseButton>
        </slot>
      </div>
    </b-form>
  </validation-observer>
</template>

<script>
import Vue from 'vue'
import {
  defineComponent,
  ref,
  watch,
  onMounted,
  onBeforeUnmount
} from '@vue/composition-api'
import { createVuexHelpers } from 'vue2-helpers'

import { UserService } from '@services'
import { BaseButton } from '@components/base'
import { UserRoleSelect } from '@components/user'

export default defineComponent({
  name: 'UserTypeForm',
  components: {
    BaseButton,

    UserRoleSelect
  },
  setup() {
    const { useGetters } = createVuexHelpers()

    const { member } = useGetters(['member'])

    const isProcessing = ref(false)

    const formRef = ref(null)
    const formData = ref({})

    const $reset = () => {
      isProcessing.value = false

      formData.value = {}

      formRef.value.reset()
    }

    const handleSubmit = async () => {
      isProcessing.value = true

      try {
        const { data } = await UserService.put(member.value.id, formData.value)
        const { status, data: results } = data || {}

        $reset()

        if (200 === status) {
          Vue.prototype.$bus.$emit('user-type-form-success', results.data)
        }

        Vue.prototype.$toasted.show(results.message)
      } catch (_) {
        $reset()
      }
    }

    watch(
      member,
      (newMember) => {
        if (!newMember.id) return

        formData.value = {
          id: newMember.id,
          display_name: newMember.user.first_name,
          type: newMember.type.replace('Company', 'Corporate')
        }
      },
      { deep: true, immediate: true }
    )

    watch(isProcessing, (newIsProcessing) =>
      Vue.prototype.$bus.$emit('user-type-form-processing', newIsProcessing)
    )

    onMounted(() => {
      Vue.prototype.$bus.trackEvent(
        'error-catched',
        () => (isProcessing.value = false)
      )
    })

    onBeforeUnmount(() => $reset())

    return {
      isProcessing,

      formRef,
      formData,

      handleSubmit
    }
  }
})
</script>
